import { render, staticRenderFns } from "./guide-tab-container.vue?vue&type=template&id=434e6180"
import script from "./guide-tab-container.vue?vue&type=script&lang=js"
export * from "./guide-tab-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_coffee-script@1.12.7_css-loader@5.2.7_webpack@5.75_86376c8867defa2ab34ac3cb7ab0bafc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports